import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconInfo = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7ZM10.9805 8.9801C10.9805 8.42782 11.4282 7.9801 11.9805 7.9801C12.5328 7.9801 12.9805 8.42782 12.9805 8.9801C12.9805 9.53239 12.5328 9.9801 11.9805 9.9801C11.4282 9.9801 10.9805 9.53239 10.9805 8.9801ZM12.9805 14.9801V10.9801H10.9805V14.9801C10.9805 15.5324 11.4282 15.9801 11.9805 15.9801C12.5328 15.9801 12.9805 15.5324 12.9805 14.9801Z"
        />
      </svg>
    );
  }
);
